export default __webpack_public_path__ + "static/media/ins_01.62c1cad3.jpg";